import { render, staticRenderFns } from "./RuleDetailDialog.vue?vue&type=template&id=b7b3786a&"
import script from "./RuleDetailDialog.vue?vue&type=script&lang=js&"
export * from "./RuleDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports